var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group col-md-7 px-0"},[_c('label',{staticClass:"text-black",attrs:{"for":"region-select"}},[_vm._v("Region")]),_c('b-select',{attrs:{"label-field":"Region","options":_vm.regions,"id":"region-select"},model:{value:(_vm.selectedRegion),callback:function ($$v) {_vm.selectedRegion=$$v},expression:"selectedRegion"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }